export default "__VITE_ASSET__fdacd160__"